import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";

export class notificationActivationStatusCtrl implements IController {

  notification: any;

  public active: boolean;

  /* @ngInject */
  constructor() {

  }


  $onChanges(changes) {
    if (changes.notification) {
      if (this.notification) {
        this.active = (this.notification.type === 'Default') && !_.isUndefined(this.notification.defaultActive) ?
          this.notification.defaultActive :
          this.notification.active;
      }
    }
  }


}

angular
  .module('bringoz.admin.notifications')
  .component('notificationActivationStatus', {
    bindings: {
      notification: '<'
    },
    template: require('./notification-activation-status.html').default,
    controller: notificationActivationStatusCtrl
  });
